//#region IMPORTS
import { FieldValues, useForm } from "react-hook-form";
import { Store } from "../../models/store";
import { toast } from "react-toastify";
import classNames from "../../helpers/classNames";
import agent from "../../api/agent";
//#endregion

//#region INTERFACE
interface Props {
  setStoreHandler: (store: Store) => void;
  cancel: () => void;
}
//#endregion

export default function InstoreOrderSearchStoreForm({
  setStoreHandler,
  cancel,
}: Props) {
  //#region SETUP

  // UseForm
  const {
    register,
    handleSubmit,
    formState: { isSubmitting, errors, isValid },
  } = useForm({ mode: "all", defaultValues: { external_store_id: "" } });
  //#endregion

  //#region LOGIC
  // Submit new search value
  async function submitForm({ external_store_id }: FieldValues) {
    try {
      const response = await agent.StoreManagement.detailByExternalId(
        external_store_id
      );
      setStoreHandler(response.data);
    } catch (error: any) {
      toast.error("No store found");
    }
  }
  //#endregion

  return (
    <form onSubmit={handleSubmit(submitForm)}>
      <div className="space-y-12">
        <div className="pb-12">
          <header>
            <h2 className="text-base font-semibold leading-7 text-gray-900">
              Search a store
            </h2>
          </header>

          <section className="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
            {/* external_store_id */}
            <fieldset className="sm:col-span-3">
              <label
                htmlFor="external_store_id"
                className={
                  errors.external_store_id
                    ? "block text-sm font-medium leading-6 text-red-900"
                    : "block text-sm font-medium leading-6 text-gray-900"
                }
              >
                {errors.external_store_id
                  ? errors?.external_store_id?.message
                  : "Search a store by store id"}
              </label>
              <div className="relative mt-2">
                <input
                  placeholder="e.g. 1500"
                  className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-amber-600 sm:text-sm sm:leading-6"
                  type="text"
                  {...register("external_store_id", {
                    required: "The external_store_id is a required field",
                  })}
                />
              </div>
            </fieldset>

            {/* Actions */}
            <div className="sm:col-span-3 mt-6 flex items-center justify-end gap-x-6">
              <button
                onClick={cancel}
                type="button"
                className="text-sm font-semibold leading-6 text-gray-900"
              >
                Cancel
              </button>

              <button
                type="submit"
                disabled={!isValid}
                className={classNames(
                  isValid
                    ? "bg-emerald-600 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-emerald-600 hover:bg-emerald-500 focus-visible:outline"
                    : "bg-gray-600 opacity-40",
                  "rounded-md  px-3 py-2 text-sm font-semibold text-white shadow-sm"
                )}
              >
                {isSubmitting ? "searching..." : "Search stores"}
              </button>
            </div>
          </section>
        </div>
      </div>
    </form>
  );
}
